import { useState } from 'react';
import type { DependentParam, TextureSoil } from '../types/parameters.types';
import {
	type EditValues,
	getClassesForTexture,
	buildMacroUpdatedParam,
} from '../utils/paramsTableUtils';

export const useMacroParamsEdit = (
	params: DependentParam[],
	texture: TextureSoil,
	onChange?: (params: DependentParam[]) => void
) => {
	const [editingCode, setEditingCode] = useState<string | null>(null);
	const [editValues, setEditValues] = useState<EditValues>({ low: '', medium: '', high: '' });

	const commitCurrent = (currentEditValues: EditValues) => {
		if (!editingCode || !onChange) return;
		const prev = params.find((p) => p.code === editingCode);
		if (!prev) return;
		const updated = buildMacroUpdatedParam(prev, currentEditValues, texture);
		onChange(params.map((p) => (p.code === editingCode ? updated : p)));
	};

	const startEdit = (param: DependentParam) => {
		if (!onChange) return;
		if (editingCode && editingCode !== param.code) {
			commitCurrent(editValues);
		}
		const { low, medium, high } = getClassesForTexture(param, texture);
		setEditingCode(param.code);
		setEditValues({ low, medium, high });
	};

	const handleInputChange = (param: DependentParam, field: keyof EditValues, value: string) => {
		const newValues = { ...editValues, [field]: value };
		setEditValues(newValues);
		if (onChange) {
			const updated = buildMacroUpdatedParam(param, newValues, texture);
			onChange(params.map((p) => (p.code === param.code ? updated : p)));
		}
	};

	return { editingCode, editValues, startEdit, handleInputChange };
};
